import React, { ReactElement, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { DEFAULT_PAGE_SIZE, INVENTROY_CONSTANTS, PAGE_QUERY_PARAM } from '../../../../shared/constants/commonConstants';
import { INVENTORY_FETCH_IP_PACKAGE } from '../../../../shared/constants/urlEndPoints';
import { FetchInPatientPackageRequest, FetchInPatientPackageResponse } from '../../../../shared/models/inPatient.model';
import SendRequest from '../../../../shared/services/sendRequest.service';
import { base64UrlDecode, base64UrlEncode, error, extractSecondLevelBaseUrl } from '../../../../utils/utility';
import DaycarePackageForm from './DaycarePackageForm';

const EditDaycarePackage = ({ match: { path, params: { id: packageId } } }: any): ReactElement => {
  const pageNumber: any = new URLSearchParams(useLocation().search).get('page');
  const [packageDetail, setPackageDetail] = useState(null as any);
  const id = base64UrlDecode(packageId);
  useEffect((): void => {
    const reqpayload: FetchInPatientPackageRequest = {
      fetchInActiveRecord: true,
      pageNumber: 1,
      pageSize: DEFAULT_PAGE_SIZE,
      packageById: true,
      ids: [+id],
      packageType: 'DayCare',
    };
    fetchPackageDetail(reqpayload);
  }, [id]);
  const fetchPackageDetail = async (
    payload: any,
  ): Promise<any> => {
    const url = process.env.REACT_APP_INVENTORY_API_BASE_URL + INVENTORY_FETCH_IP_PACKAGE;
    const result: FetchInPatientPackageResponse = await SendRequest.instance.post<
      FetchInPatientPackageRequest,
      FetchInPatientPackageResponse
    >(url, payload);
    if (result && result.isSuccess && result.packages && result.packages.length > 0) {
      setPackageDetail(result.packages[0]);
    } else {
      error('Please try again');
    }
  };
  return (
    <div>
      <DaycarePackageForm path={path}
        backUrl={extractSecondLevelBaseUrl(path) +
          INVENTROY_CONSTANTS.daycarePackageDetailRoute +
          base64UrlEncode(packageDetail?.id) + PAGE_QUERY_PARAM + (pageNumber ? pageNumber : 1)}
        pageTitle={'Day Care Pacakge'} data={packageDetail} />
    </div>
  );
};

export default EditDaycarePackage;
